import { MortgageCertificateFormFields, MortgageCertificateRequest } from 'src/@types';
import { currencyToNumber, stringToBoolean } from '../../../../../utils';
import { mortgageCertificateFormFields } from '../config';

const prepareFormData = ({
  appointmentDate,
  firstname,
  lastname,
  partnerFirstname,
  partnerLastname,
  street,
  houseNumber,
  postcode,
  city,
  phoneNumber,
  interestRate,
  mortgageAmount,
  mortgageYears,
  ownResources,
  nhg,
  newHouseStreet,
  newHouseHouseNumber,
  newHousePostcode,
  newHouseCity,
  newHouseEnergyLabel,
  officeId,
  issueDate,
  consultantName
}: MortgageCertificateFormFields): MortgageCertificateRequest => {
  return {
    appointmentDate,
    issueDate,
    firstname,
    lastname,
    partnerFirstname,
    partnerLastname,
    street,
    houseNumber,
    postcode,
    city,
    phoneNumber,
    interestRate,
    mortgageAmount: currencyToNumber(mortgageAmount),
    mortgageYears: currencyToNumber(mortgageYears),
    ownResources: currencyToNumber(ownResources),
    totalAmount: currencyToNumber(mortgageAmount) + currencyToNumber(ownResources),
    nhg: stringToBoolean(nhg),
    newHouseStreet,
    newHouseHouseNumber,
    newHousePostcode,
    newHouseCity,
    energyLabel: newHouseEnergyLabel,
    officeId: currencyToNumber(officeId),
    consultantName
  };
};

const getDefaultValues = (): MortgageCertificateFormFields => {
  return {
    appointmentDate: mortgageCertificateFormFields.appointmentDate.defaultValue,
    firstname: mortgageCertificateFormFields.firstname.defaultValue,
    lastname: mortgageCertificateFormFields.lastname.defaultValue,
    partnerFirstname: mortgageCertificateFormFields.partnerFirstname.defaultValue,
    partnerLastname: mortgageCertificateFormFields.partnerLastname.defaultValue,
    street: mortgageCertificateFormFields.street.defaultValue,
    houseNumber: mortgageCertificateFormFields.houseNumber.defaultValue,
    postcode: mortgageCertificateFormFields.postcode.defaultValue,
    city: mortgageCertificateFormFields.city.defaultValue,
    phoneNumber: mortgageCertificateFormFields.phoneNumber.defaultValue,
    interestRate: mortgageCertificateFormFields.interestRate.defaultValue,
    mortgageAmount: mortgageCertificateFormFields.mortgageAmount.defaultValue,
    mortgageYears: mortgageCertificateFormFields.mortgageYears.defaultValue,
    ownResources: mortgageCertificateFormFields.ownResources.defaultValue,
    nhg: mortgageCertificateFormFields.nhg.defaultValue,
    newHouseStreet: mortgageCertificateFormFields.newHouseStreet.defaultValue,
    newHouseHouseNumber: mortgageCertificateFormFields.newHouseHouseNumber.defaultValue,
    newHousePostcode: mortgageCertificateFormFields.newHousePostcode.defaultValue,
    newHouseCity: mortgageCertificateFormFields.newHouseCity.defaultValue,
    newHouseEnergyLabel: mortgageCertificateFormFields.newHouseEnergyLabel.defaultValue,
    officeId: mortgageCertificateFormFields.officeId.defaultValue,
    //officeStreet: mortgageCertificateFormFields.officeStreet.defaultValue,
    //officeHouseNumber: mortgageCertificateFormFields.officeHouseNumber.defaultValue,
    //officePhoneNumber: mortgageCertificateFormFields.officePhoneNumber.defaultValue,
    //officePostcode: mortgageCertificateFormFields.officePostcode.defaultValue,
    //officeCity: mortgageCertificateFormFields.officeCity.defaultValue,
    issueDate: mortgageCertificateFormFields.issueDate.defaultValue,
    consultantName: mortgageCertificateFormFields.consultantName.defaultValue
  };
};

export { prepareFormData, getDefaultValues };
